import React, { useEffect, useState } from 'react'
import "./LoginPage.css";
import { Link, useParams } from "react-router-dom";
import LoginForm from '../../components/LoginForm/LoginForm';
import ForgotPasswordModal from '../../components/Modals/ForgotPasswordModal/ForgotPasswordModal';
import Footer from '../../components/Footer/Footer';
import StickyNotification from '../../components/StickyNotification/StickyNotification';
import * as translator from "../../utils/translator";
import LoginPageHeader from '../../components/Headers/HeaderV2025/LoginPageHeader';
import SocialLoginButtons from '../../components/LoginStrategies/SocialLoginButtons';
import { useCartContext } from '../../customHooks/useCart';
import * as http from "../../utils/http";
import UspBarV2025 from '../../components/UspBarV2025/UspBarV2025';
import AcceptedPaymentMethodsBanner from '../../components/AcceptedPaymentMethodsBanner/AcceptedPaymentMethodsBanner';


const LoginPage = () => {

  const {country} = useParams();
  const language = translator.getLanguageByCountry(country);
  const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false);
  const [stickyNotificationDetails, setStickyNotificationDetails] = useState({ // global state for sticky handling
    show: false,
    title: "",
    content: "",
    level : "",
    showInfoIcon:true,
    refresh:false,
  });
  
  const {saveCart, clearCart} = useCartContext()
  const [paymentIcons, setPaymentIcons] = useState<any[]>([]);

  const loginInfoCards = [ 
    {
      title:translator.translate(language, "authentication", 'LoginPage/login_info_card_1_title'),
      content:translator.translate(language, "authentication", 'LoginPage/login_info_card_1_content'),
    },
    {
      title:translator.translate(language, "authentication", 'LoginPage/login_info_card_2_title'),
      content:translator.translate(language, "authentication", 'LoginPage/login_info_card_2_content'),
    },
    {
      title:translator.translate(language, "authentication", 'LoginPage/login_info_card_3_title'),
      content:translator.translate(language, "authentication", 'LoginPage/login_info_card_3_content'),
    },
    {
      title:translator.translate(language, "authentication", 'LoginPage/login_info_card_4_title'),
      content:translator.translate(language, "authentication", 'LoginPage/login_info_card_4_content'),
    },
  ]

  const loginInfoStats = [
    {
      value: "1M+", // '600k+ customers'
      label: translator.translate(language, "authentication", "LoginInfoStats/customers"),
      style: { top: '14%', left: 0 },
      extraClassName: "login-info-stat-translate-left",
    },
    {
      value: country?.toLowerCase() === "de" ? "40+" : "36+",
      label: translator.translate(language, "authentication", "LoginInfoStats/categories"),
      style: { top: '54%', left: 0 },
      extraClassName: "login-info-stat-translate-left-130",
    },
    {
      value: "4M", // '4M orders'
      label: translator.translate(language, "authentication", "LoginInfoStats/orders"),
      style: { top: 0, right: 0 },
      extraClassName: "login-info-stat-translate-right-110",
    },
    {
      value: `${(d => d.getFullYear() - 2018 - (d.getMonth() < 3 ? 1 : 0))(new Date())}+`, // years since April 2018
      label: translator.translate(language, "authentication", "LoginInfoStats/years_of_trust"),
      style: { bottom: '40%', right: 0 },
      extraClassName: "login-info-stat-translate-right-135",
    },
  ]

  useEffect(() => {
  const cartToken = window.eventsTracking.getData("cart_token");
  if(cartToken && cartToken != "undefined"){
    http
      .getFromServer("cart", [http.MIDDLEWARES.CART_ORDER, http.MIDDLEWARES.CUSTOMER_ID])
      .then((response) => {
        if (response.data && response.data.products && response.data.products.length > 0) {
          const cartData = {
            ...response.data.cart,
            products: response.data.products
          };
          saveCart({...cartData, timekitBooking: cartData.timekitBooking || null});
        }
        if (Array.isArray(response.data?.paymentIcons) && response.data.paymentIcons.length > 0) {
          setPaymentIcons(response.data.paymentIcons);
        }
      })
      .catch((error) => {
        window.clientLogger.error("Failed to fetch cart data:", error);
        clearCart();
      });
  }
  // No cart: the banner falls back to its static icons rather than spending a
  // request on them, so the page makes no call at all.
  }, []);

  useEffect(() => {
    const scriptSrc = 'https://integrations.etrusted.com/applications/widget.js/v2';
    if (!document.querySelector(`script[src="${scriptSrc}"]`)) {
      const script = document.createElement('script');
      script.src = scriptSrc;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }
  }, []);

  if(language && country){
    return (
      <>
      <div className="login-page">
      <UspBarV2025 />
       <div className="bg-black">
        <div className="rounded-t-[30px] overflow-hidden">
          <LoginPageHeader breadcrumbLabel={translator.translate(language, "authentication", 'header/registration')} />
        </div>
       </div>

          <StickyNotification
              showNotification={stickyNotificationDetails.show}
              title={stickyNotificationDetails.title}
              onClick={() => setStickyNotificationDetails((currentDetails:any) => { return {...currentDetails, show:false}})}  
              content={stickyNotificationDetails.content}
              level={stickyNotificationDetails.level}
              showInfoIcon={stickyNotificationDetails.showInfoIcon}
              refresh={stickyNotificationDetails.refresh}
          />

          {
            showForgotPasswordModal &&           
            <ForgotPasswordModal
              closeModal={() => setShowForgotPasswordModal(false)}
              language={language}
              setStickyNotificationDetails={setStickyNotificationDetails}
            />  
          }

          <div className="login-content-container py-[25px] md:py-[50px]">
            <div className="login-content flex items-center justify-center gap-0 md:gap-[50px]">
              <div className="login-form-container">
                {/* welcome title */}
                <h2 className="font-semibold leading-[1.2] text-[22px] md:text-[32px] text-center mb-[6px] md:mb-[12px] linear-text-color-primary">
                  {translator.translate(language, "authentication", 'LoginPage/welcome_back')}
                </h2>
                
                <span id="login-form-container-title" className="text-[16px] leading-[1.2] md:text-[22px] font-regular font-poppins text-center mb-[32px]" >{translator.translate(language, "authentication", 'LoginPage/login_form_title')}</span>

                  {/* Buttons for social login */}
                  <SocialLoginButtons 
                    redirectPath={`${country}/login${window.location.search}`}
                    cameFromPath={`${country}/login`}
                    language={language}
                    country={country}
                    onCompleteSignup={() => window.location.reload()}
                    onFailureSignup={() => {     // Show sticky notification error
                      setStickyNotificationDetails({
                        show: true,
                        title: translator.translate(language, "default", "StickyNotification/danger_title"),
                        content: translator.translate(language, "default", "StickyNotification/oauth_failed"),
                        level: "error", 
                        showInfoIcon: true,
                        refresh: false
                      });
                     }}
                  />

                  {/* Divider */}
                  <div id="login-form-container-or" className="flex flex-row items-center justify-center gap-[6px] mb-[9px] mt-[24px]">
                    <div id="login-form-container-or-line-left" className="h-[1px] bg-[#E5E5E5] flex-1" />
                    <span id="login-form-container-or-text" className="text-[12px] font-regular font-poppins text-[#99A3B2] uppercase">{translator.translate(language, "authentication", 'LoginPage/or_continue_with_email')}</span>
                    <div id="login-form-container-or-line-right" className="h-[1px] bg-[#E5E5E5] flex-1"/>
                  </div>

                  {/* Login form */}
                  <LoginForm 
                    language={language} 
                    country={country}
                    submitButtonPlaceholder={translator.translate(language, "authentication", 'LoginPage/submit')}
                    setStickyNotificationDetails={setStickyNotificationDetails}
                  />

                  {/* Forgot password link */}
                  <span onClick={()=> setShowForgotPasswordModal(true)} id="forgot-password-link" className="my-[14px] text-[14px] font-[400] font-poppins text-[#777777] text-center underline cursor-pointer">{translator.translate(language, "authentication", 'LoginPage/forgot_password')}</span>
                
                  {/* New to DoktorABC link */}
                  <span id="new-to-doktorabc" className="text-[14px] font-[400] font-poppins text-center">
                    {translator.translate(language, "authentication", 'LoginPage/new_to_doktorabc')}
                    <br className='block md:hidden'/>
                    <Link to={`/${country}/register${window.location.search}`} id="register-now-link" className="underline cursor-pointer ml-[0.5em] linear-text-color-primary"

                    >
                    {translator.translate(language, "authentication", 'LoginPage/register_now')}
                    </Link>
                  </span>

              </div>

              <div>                
                <div className="login-info relative lg:px-[120px] flex flex-col items-center max-w-[650px]">
                  <div
                    id="login-info-overlay"
                    className="absolute top-0 bottom-[0] bottom-[-90px] lg:bottom-[30px] left-[-15px] right-[-15px] lg:left-[50px] lg:right-[50px] bg-[#F6F7F9] rounded-[24px] lg:rounded-[45px]"
                  >
                  </div>

                  <div
                    id="login-info-content"
                    className="relative"
                  >
                    <h3 className="text-center text-[24px] font-poppins font-[600] lg:font-normal mt-[25px] mb-[20px]">
                      <span
                        className="font-[600] leading-[1] linear-text-color-primary"
                      >{translator.translate(language, "authentication", 'LoginPage/login_info_title_highlight')}</span>
                      <span className="text-[#08080A] leading-[1]">{translator.translate(language, "authentication", 'LoginPage/login_info_title_regular')}</span>
                    </h3>
                    <div id="login-info-cards-container" className="grid grid-rows-[auto_auto_auto_auto] lg:grid-rows-[1fr_1fr_1fr_1fr] gap-[12px]">
                      {
                        loginInfoCards.map((loginInfoCard:any,index:number) => (
                          <div key={index} id="login-info-card" className="bg-white rounded-[16px] p-[14px] lg:p-[20px] flex flex-col gap-[10px] relative shadow-[0_17px_35px_0_#CED0D870,0_-10px_19px_0_#FFFFFFD1]">
                              <span id="login-info-card-content-title font-poppins"
                                className="font-[600] text-[16px] leading-[1.2] linear-text-color-primary"
                                >{loginInfoCard.title}</span>
                              <p className="login-info-card-content-content font-poppins">{loginInfoCard.content}</p>
                          </div>
                        ))
                      }
                    </div>

                    <div id="login-info-stats" className="grid grid-cols-2 grid-rows-2 gap-[12px] mt-[35px] lg:mt-0 lg:gap-0 w-full">
                      {
                        loginInfoStats.map((loginInfoStat:any,index:number) => (
                          <div key={index} className={`login-info-stat flex flex-col items-center justify-center bg-[#F5F6F7] rounded-[16px] py-[20px] border shadow-[0_12px_18px_0_#CED0D8B3] lg:absolute lg:px-[10px] lg:w-[120px] ${loginInfoStat.extraClassName || ''}`} style={{border: '1px solid #FFFFFF', ...loginInfoStat.style}}>
                            <span 
                              id="login-info-stat-value"
                              className="text-[22px] font-[600] font-poppins leading-[1] linear-text-color-primary"
                            >{loginInfoStat.value}</span>
                            <span id="login-info-stat-label" className="text-[16px] font-[300] font-poppins leading-[1] text-[#000000] text-center">{loginInfoStat.label}</span>
                          </div>
                        ))
                      }
                    </div>
                  </div>

                </div>


                <div className="flex justify-center my-[20px]">
                  <etrusted-widget data-etrusted-widget-id="wdg-be5e4d0d-9dd0-4baf-98dd-a28827065994"></etrusted-widget>
                </div>
              </div>

            </div>
          </div>

          <div
            id="login-page-accepted-payment-methods-banner-container"
            className="mb-[15px] mt-auto"
          >
            <AcceptedPaymentMethodsBanner paymentIcons={paymentIcons} />
          </div>

          <Footer page="CheckoutRegister" language={country} />  
      </div>
      </>
    )
  } else {
    return <></>
  }
}

export default LoginPage





